import AdminApiService from "src/api/AdminApiService";
import BinAssemblySubmittalDTO from "src/models/BinAssemblySubmittalDTO";
import { deviceQueryKeys } from "src/components/BinDetails";
import { queryOptions } from "./v4QueryOptions/queryOptions";

export const getBinAssemblySubmittalQueryOptions = (deviceId: string) => queryOptions({
    queryKey: [...deviceQueryKeys.device(deviceId), "getBinAssemblySubmittalQuery"],
    queryFn: async (q) => {
        if(deviceId != ""){
            return await AdminApiService.getBinAssemblySubmittal(deviceId, q.signal);
        }
        return {} as BinAssemblySubmittalDTO;
    },
});